import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { ViewableQuestion } from '../types/global';

export interface AppContextType {
  debugMode: boolean;
  setDebugMode: React.Dispatch<React.SetStateAction<boolean>>;
  debugQuestion: ViewableQuestion['extId'] | null;
  setDebugQuestion: React.Dispatch<
    React.SetStateAction<ViewableQuestion['extId'] | null>
  >;
}

export const AppContext = createContext<AppContextType>({
  debugMode: false,
  setDebugMode: () => null,
  debugQuestion: null,
  setDebugQuestion: () => null,
});

interface AppContextProviderProps {
  children: ReactNode;
}

export const AppContextProvider = ({ children }: AppContextProviderProps) => {
  const [debugMode, setDebugMode] = useState(
    sessionStorage.getItem('debugMode') === 'true',
  );
  const [debugQuestion, setDebugQuestion] = useState<
    ViewableQuestion['extId'] | null
  >(null);

  useEffect(() => {
    sessionStorage.setItem('debugMode', String(debugMode));
  }, [debugMode]);

  return (
    <AppContext.Provider
      value={{
        debugMode,
        setDebugMode,
        debugQuestion,
        setDebugQuestion,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = (): AppContextType => useContext(AppContext);

export const useDebugMode = (): [
  AppContextType['debugMode'],
  AppContextType['setDebugMode'],
] => {
  const { debugMode, setDebugMode } = useContext(AppContext);
  return [debugMode, setDebugMode];
};
